import React, { Component } from 'react';

export default class Pessoa extends Component {
    render() {
        return (
            <div className="person">
                <img src={this.props.item.photo}></img>
                <p className="name">{this.props.item.name}</p>
                <p className="position">{this.props.item.position}</p>
            </div>
        )
    }
}
